import { render, staticRenderFns } from "./UpskillCourses.vue?vue&type=template&id=0df18b1e&scoped=true&"
import script from "./UpskillCourses.vue?vue&type=script&lang=ts&"
export * from "./UpskillCourses.vue?vue&type=script&lang=ts&"
import style0 from "./UpskillCourses.vue?vue&type=style&index=0&id=0df18b1e&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0df18b1e",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VChip } from 'vuetify/lib/components/VChip';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VChip,VCol,VIcon,VRow})
